import type { LocalizedOptionList } from '../hooks/localization/tOptions';

/**
 * The value codes behind the event option lists, owned here rather than read out of the translation
 * bundles: the codes are what an event stores (focusArea, primaryActivity, sponsors) and what the
 * labels are keyed by, so they must not depend on a language pack having loaded. The i18next key and
 * the ARB id prefix travel with each list; a contract test pins every code below to a label id.
 *
 * The namespace prefix on each key is explicit so a list resolves to its own bundle whatever
 * namespace order the calling component declares.
 */

export const FOCUS_AREAS: LocalizedOptionList = {
  i18nKey: 'events:focus',
  idPrefix: 'focus_zone',
  values: [
    'disaster-relief',
    'stem',
    'career-exploration',
    'literacy',
    'school-essentials',
    'edu-other',
    'food-security',
    'environment-and-sustainability',
    'housing',
    'health',
    'animal-welfare',
    'other',
  ],
};

export const PRIMARY_ACTIVITIES: LocalizedOptionList = {
  i18nKey: 'events:activity',
  idPrefix: 'activity_zone',
  values: [
    'general-community-service',
    'packing-assembly',
    'mentoring-tutoring',
    'career-workforce-support',
    'nonprofit-board-service',
    'professional-services',
  ],
  // The legacy list carries a description per activity, so the ARB list reads them too and both
  // states of the flag show the same thing.
  withDescriptions: true,
};

export const ELG_SPONSORS: LocalizedOptionList = {
  i18nKey: 'attendance:sponsors',
  idPrefix: 'sponsors',
  values: [
    'amazonpwd',
    'awe',
    'arabs@',
    'aata',
    'ben',
    'bpp',
    'caribbean-connection',
    'connect@',
    'families@',
    'glamazon',
    'hindus@',
    'inclusion',
    'indigenous@',
    'jewish@',
    'latinos@',
    'mhw@',
    'sustainability',
    'trans@',
    'warriors@',
    'wifi',
    'women@',
  ],
};

/**
 * Days of the week for the search filters. A `translation`-namespace list resolving through
 * NS_TO_BUNDLES.translation, which carries the options.daysOfWeek bundle. Value codes are the day
 * indices (0 = Sunday) the filters store in the days_of_week URL param, matching the i18next
 * daysOfWeekOptions list.
 */
export const DAYS_OF_WEEK: LocalizedOptionList = {
  i18nKey: 'translation:daysOfWeekOptions',
  idPrefix: 'daysOfWeekOptions',
  values: ['0', '1', '2', '3', '4', '5', '6'],
};
